module.exports = "<div class=\"col-md-12 p-0\">\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/iglesias/iglesias.component.html
// module id = ./src/app/admin/pages/iglesias/iglesias.component.html
// module chunks = main